<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card border border-radius-12">
          <div class="card-body table mb-0">
            <div class="toolbar-container px-3">
              <div class="toolbar-row d-flex align-items-center justify-content-between mb-2">
                <PageHeader :title="title" :items="itemsBreadcrumb" class="poppins fw-normal ps-0 text-nowrap" />
                <div class="d-flex gap-2 flex-wrap p-0 buttons-container">
                  <CustomButton 
                    :buttonText="downloadReportProcessing ? 'Please wait...' : 'Download Report'"
                    class="p-0"
                    :loading = "downloadReportProcessing"
                    :disabled="downloadReportProcessing"
                    @click="downloadReport" 
                  />
                  <CustomLinkButton 
                    buttonText="Create New" 
                    class="p-0"
                    linkTo="/email-content/add"
                  />
                </div>
              </div>

              <div class="toolbar-row d-flex gap-2 align-items-center">
                <searchInput @getSearched="handleSearch" class="p-0" />
                <pageSize @getPageSize="handlePageSize" class="page-size-btn p-0" />     
              </div>
            </div>
            <GeneralTable :isProcessing="processing" :items="items" :fields="fields" :showEyeButton="true"
              :showActionButton="true" :showEditButton="true" :showDeleteButton="true" @deleteItem="deleteEmail"
              @editItem="emailUpdate" @showItem="showEmail" />

              <Pagination @paginator="getEmails" :pagination="paginatelinks" :showing="paginate"
              @page-changed="handlePageChange" />

              <b-modal ref="previewModal" size="xl" hide-footer title="Email Preview">
                  <iframe v-if="previewHtml" :srcdoc="previewHtml" class="w-100 border rounded"
                      style="height:80vh;"></iframe>
              </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import appConfig from "@/app.config";
import GeneralTable from "../../../../components/MagicTable/GeneralTable.vue";
import Pagination from "../../../../components/general/pagination.vue";
import searchInput from "../../../../components/general/searchInput.vue";
import pageSize from "../../../../components/general/pageSize.vue";
import CustomButton from "../../../../components/CustomButton.vue";
import CustomLinkButton from "../../../../components/CustomLinkButton.vue";
export default {
  page: {
    title: "Emails Notification",
    meta: [
      {
        name: "email-content",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    GeneralTable,
    Pagination,
    searchInput,
    pageSize,
    CustomButton,
    CustomLinkButton
  },

  data() {
    return {
      title: "Emails Notification",

      fields: [
        { key: "id", label: "ID", tdClass: "align-middle" },
        { key: "subject", label: "Subject", tdClass: "align-middle" },
        { key: "type", label: "Type", tdClass: "align-middle" },
        { key: "details", label: "Details", tdClass: "align-middle" },
        { key: "dynamic_keys", label: "Dynamic Keys", tdClass: "align-middle" },
        { key: "created_at", label: "Created At", tdClass: "align-middle" },
        { key: "action", tdClass: "" },
      ],

      items: [],
      processing: false,

      paginate: {},
      paginatelinks: [],
      pageSize: 25,
      search: null,

      selectedEmail: null,
      emailLoading: false,

      downloadReportProcessing: false,
      previewHtml:null
    };
  },

  computed: {
    itemsBreadcrumb() {
      return [
        { text: "Omaha" },
        { text: "Emails Notification", active: true },
      ];
    },
  },

  mounted() {
    let url = null;
    if (this.$route.query.currentPage) {
      url = `email-content?page=${this.$route.query.currentPage}`;
    }
    this.getEmails({ url, pageSize: this.pageSize });
    this.processing = true;
  },

  methods: {
    formatDate(isoDate) {
      if (!isoDate) return "N/A";

      const date = new Date(isoDate);
      if (isNaN(date.getTime())) return isoDate;

      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();

      const getDaySuffix = (d) => {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      };

      return `${day}${getDaySuffix(day)} ${month} ${year}`;
    },

    handleSearch(searchItem) {
      this.search = searchItem;
      this.getEmails({ searchItem, pageSize: this.pageSize });
    },

    handlePageSize(newPageSize) {
      this.pageSize = newPageSize || 25;
      this.getEmails({ pageSize: this.pageSize, searchItem: this.search });
    },

    handlePageChange(pageNumber) {
      const baseUrl = "email-content";
      const pageUrl = `${baseUrl}?page=${pageNumber}`;
      this.getEmails({ url: pageUrl, pageSize: this.pageSize, searchItem: this.search });
    },
    emailUpdate(emailId) {
        this.$router.push(`/email-content/add?emailId=${emailId}`);
    },
    showEmail(emailId) {
      let content = this.items.find((item) => item.id === emailId);
      this.$axios.post("email-content/get-preview", { body: content.body }).then((response) => {
        this.previewHtml = response.data.html;
        this.$refs.previewModal.show();
      });
    },
    deleteEmail(id) {

      this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios.delete(`email-content/${id}`)
          .then((response) => {
              this.getEmails();
              this.triggerSwal?.("Email deleted successfully.", "success");
          })
          .catch((error) => {
            this.triggerSwal?.("Something went wrong while deleting.", "error");
          });
        }
      });
    },
    randerData(response) {
      const payload = response?.data || {};
      this.paginate = {
        first_page: payload.data.first_page_url,
        last_page_url: payload.data.last_page_url,
        last_page: payload.data.last_page,
        links: payload.data.links,
        from: payload.data.from,
        to: payload.data.to,
        total: payload.data.total,
      };

      this.paginatelinks = (this.paginate.links || []).map((item) => ({
        url: item.url,
        label: item.label,
        active: item.active,
      }));

      const rows = Array.isArray(payload?.data.data) ? payload.data.data : [];


      this.items = rows.map((row) => ({
        id: row.id,
        subject: row.subject || "N/A",
        type: row.type || "N/A",
        details: row.details || "N/A",
        created_at: this.formatDate(row.created_at),
        body: row.body || "N/A",
        dynamic_keys: this.formattedTypeKeys(row.dynamic_keys_array) || "N/A",
      }));

      this.processing = false;
    },
    formattedTypeKeys(keys) {
        return keys.map(key => `@{${key}}`).join(' ');
    },
    getEmails({ url = null, searchItem = null, pageSize = this.pageSize } = {}) {
      this.processing = true;

      let endPoint = "email-content";
      endPoint = url ? url : endPoint;

      this.$axios
        .get(endPoint, {
          params: {
            search: searchItem,
            page_size: pageSize,
          },
        })
        .then((response) => {
          setTimeout(() => this.randerData(response), 300);
        })
        .catch((error) => {
          console.log(error?.response || error);
          this.processing = false;
        });
    },

    async downloadReport() {
      if (this.downloadReportProcessing) return;

      this.downloadReportProcessing = true;

      try {
        const total = this.paginate?.total || 0;

        if (!total) {
          this.triggerSwal?.("No data available to download.", "warning");
          return;
        }

        const response = await this.$axios.get("email-content", {
          params: {
            search: this.search,
            page_size: total,
          },
        });

        const payload = response?.data?.data || {};
        const rows = Array.isArray(payload?.data) ? payload.data : [];

        if (!rows.length) {
          this.triggerSwal?.("No data available to download.", "warning");
          return;
        }

        const headers = [
          "ID",
          "Subject",
          "Type",
          "Details",
          "Dynamic Keys",
          "Created At",
        ];

        const csvRows = rows.map((row) => [
          row.id,
          row.subject || "N/A",
          row.type || "N/A",
          row.details || "N/A",
          this.formattedTypeKeys(row.dynamic_keys_array) || "N/A",
          row.created_at ? this.formatDate(row.created_at) : "N/A",
        ]);

        let csvContent = headers.join(",") + "\n";

        csvRows.forEach((row) => {
          csvContent +=
            row
              .map((value) =>
                `"${String(value ?? "")
                  .replace(/"/g, '""')
                  .replace(/\n/g, " ")}"`
              )
              .join(",") + "\n";
        });

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `email-notifications-${Date.now()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
        this.triggerSwal?.("Something went wrong while downloading.", "error");
      } finally {
        this.downloadReportProcessing = false;
      }
    },

  },
};
</script>

<style scoped>
.email-iframe {
  width: 100%;
  height: 70vh;
  border: 1px solid #ddd;
  border-radius: 10px;
  background: #fff;
}
.toolbar-container {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}

.toolbar-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  width: 100%;
}
@media (max-width : 576px){
  .card-body{
    padding : 0.25rem !important;
  }
  .toolbar-row {
    justify-content: flex-start;
  }

  .toolbar-row:first-child {
    flex-direction: column;
    align-items: flex-start;
  }
  .buttons-container{
    width : 100%;
  }
}
@media (max-width: 768){
  .table > :not(caption) > * > *
  {
    padding: 0.25rem !important;
  }
}
</style>